import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  atRegisterForm: boolean = false;
  formHeading = [
    {
      title: 'Credit Card',
      subTitle: 'Please provide the following details to continue'
    }
  ]
  submitBtnText = 'MAKE PAYMENT';
  draftBtnText = 'PREVIOUS';
  monthOptions = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 },
  ];
  yearOptions = []

  inputDataList = [
    [
      {
        label: "Card Number",
        type: "number",
        controllerName: "cardNumber",
        required: true,
        valueType: "number",
        hide: false,
        placeholder: "Card Number",
      },
      {
        label: "Card Holder Name",
        type: "number",
        controllerName: "cardHolderName",
        required: true,
        valueType: "text",
        hide: false,
        placeholder: "Card Holder Name",
      },
      {
        label: "MM",
        type: "number",
        controllerName: "expiry_month",
        // option: this.monthOptions,
        required: true,
        valueType: "number",
        hide: false,
        placeholder: "MM",
      },
      {
        label: "YYYY",
        type: "number",
        controllerName: "expiry_year",
        // option: this.yearOptions,
        required: true,
        valueType: "number",
        hide: false,
        placeholder: "YYYY",
      },
      {
        label: "CVV",
        type: "number",
        controllerName: "CVV",
        required: true,
        valueType: "number",
        hide: false,
        placeholder: "CVV",
      },
    ],
  ]

  constructor() {
    const date = new Date();
    let currYear = date.getFullYear();
    console.log("currYear", currYear);

    for (let year = currYear; year <= 2100; year++) {
      console.log(year);
      this.yearOptions.push({ name: year, value: year })
    }
  }

  ngOnInit(): void {
  }

  paymentGatewayRes(paymentGateway) {
    console.log('in payment page', paymentGateway);
    this.formHeading[0].title = paymentGateway;
    if (paymentGateway == 'Debit Card' || paymentGateway == 'Credit Card' || paymentGateway == 'Net Banking' || paymentGateway == 'Wallet') {
      let dataFields = [
        [
          {
            label: "Card Number",
            type: "number",
            controllerName: "cardNumber",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Card Number",
          },
          {
            label: "Card Holder Name",
            type: "number",
            controllerName: "cardHolderName",
            required: true,
            valueType: "text",
            hide: false,
            placeholder: "Card Holder Name",
          },
          {
            label: "MM",
            type: "number",
            controllerName: "expiry_month",
            // option: this.monthOptions,
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "MM",
          },
          {
            label: "YYYY",
            type: "number",
            controllerName: "expiry_year",
            // option: this.yearOptions,
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "YYYY",
          },
          {
            label: "CVV",
            type: "number",
            controllerName: "CVV",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "CVV",
          },
        ],
      ]

      this.inputDataList = dataFields;
    } else if (paymentGateway == 'UPI') {
      let dataFields = [
        [
          {
            label: "Enter UPI ID",
            type: "text",
            controllerName: "cardNumber",
            required: true,
            valueType: "text",
            hide: false,
            placeholder: "Enter UPI ID",
          },
        ],
      ]

      this.inputDataList = dataFields;
    } 
    // else if (paymentGateway == 'Net Banking') {

    // } else if (paymentGateway == 'Wallet') {

    // }

  }

  formButtonResEvent(event) {
    console.log(event);

  }

}
